const validate = (values, form) => {
  const errors = {};

  // first unit object should not be blank
  if (!values.units || !values.units[0] || !Object.keys(values.units[0]).length) {
    errors.hasUnit = { _error: 'You must add at least one unit.' };
  } else {
    const unitArrayErrors = [];
    values.units.forEach((unit, unitIndex) => {
      const unitErrors = {};
      if (!unit || !unit.sq_footage) {
        unitErrors.sq_footage = 'Required';
        unitArrayErrors[unitIndex] = unitErrors;
      }
      if (unit.sq_footage && isNaN(unit.sq_footage)) {
        unitErrors.sq_footage = 'Square Footage should be a number';
        unitArrayErrors[unitIndex] = unitErrors;
      }
      if (!unit || !unit.market_rent) {
        unitErrors.market_rent = 'Required';
        unitArrayErrors[unitIndex] = unitErrors;
      }
      if (!unit || !unit.number_of_baths) {
        unitErrors.number_of_baths = 'Required';
        unitArrayErrors[unitIndex] = unitErrors;
      }
      if (!unit || unit.unit_type_id === undefined) {
        unitErrors.unit_type_id = 'Required';
        unitArrayErrors[unitIndex] = unitErrors;
      }
      if (
        form.values.units &&
        form.values.units.filter(_unit => _unit.unit_number === unit.unit_number).length > 1
      ) {
        unitErrors.unit_number = 'Must be unique';
        unitArrayErrors[unitIndex] = unitErrors;
      }
      if (!unit || !unit.unit_number) {
        unitErrors.unit_number = 'Required';
        unitArrayErrors[unitIndex] = unitErrors;
      }
    });
    if (unitArrayErrors.length) {
      errors.units = unitArrayErrors;
    }
  }

  if (!values.use_communal_showings) {
    errors.use_communal_showings = 'Required';
  } else if (values.use_communal_showings === 'false') {
    if (!values.leasing_agents || !values.leasing_agents[0]) {
      errors.hasLeasingAgent = { _error: 'You must add at least one agent.' };
    }
  }

  if (!values.owners) {
    errors.owner = 'Required';
  }

  if (!values.name) {
    errors.name = 'Required';
  }
  if (!values.third_party_manager) {
    errors.third_party_manager = 'Required';
  }
  if (!values.charge_application_fee) {
    errors.charge_application_fee = 'Required';
  }
  if (values.charge_application_fee === 'true') {
    if (!values.application_fee_towards_deposit) {
      errors.application_fee_towards_deposit = 'Required';
    }
    if (!values.deposit_as_fee) {
      errors.deposit_as_fee = 'Required';
    }
    if (values.deposit_as_fee === 'false') {
      if (!values.application_fee || !values.application_fee.trim()) {
        errors.application_fee = 'Required';
      }
    }
  }

  if (values.third_party_manager === 'true') {
    if (!values.first_name) {
      errors.first_name = 'Required';
    }
    if (!values.last_name) {
      errors.last_name = 'Required';
    }
    if (!values.email) {
      errors.email = 'Required';
    }
    if (values.must_sign_lease === undefined) {
      errors.must_sign_lease = 'Required';
    }
    if (values.send_invitation === undefined) {
      errors.send_invitation = 'Required';
    }
  }

  if (!values.property_type) {
    errors.property_type = 'Required';
  }

  if (!values.street) {
    errors.street = 'Required';
  }
  if (!values.city) {
    errors.city = 'Required';
  }
  if (!values.province) {
    errors.province = 'Required';
  }
  if (!values.postal_code) {
    errors.postal_code = 'Required';
  }
  if (!values.country) {
    errors.country = 'Required';
  }
  if (values.province === 'Ontario' && !values.n1_or_n2) {
    errors.n1_or_n2 = 'Required';
  }

  if (!values.pets) {
    errors.pets = 'Required';
  }
  if (!values.utilities) {
    errors.utilities = 'Required';
  }

  return errors;
};

export default validate;
